import React from 'react';
import Grid from '@mui/material/Grid2';

import { 
  RollableTable,
} from "@dndModels";

import CommonUtilities from "@utilities/common_utilities";
import DisplayStringWithReplacements from "@dndComponents/display/DisplayStringWithReplacements";

interface Props {
  rollable_table: RollableTable;
  name: string;
}

const common_util = CommonUtilities.getInstance();

export default function RollableTableRoller({
  rollable_table,
  name,
}: Props) {
  let result = "";
  const roll = common_util.get_random(rollable_table.dice_size);
  const option_finder = rollable_table.roll_options.filter(o => o.min_roll <= roll && roll <= o.max_roll);
  if (option_finder.length === 1) {
    const option = option_finder[0];
    result = option.result;
  }
  return (
    <Grid container spacing={0} direction="row" 
      style={{
        background: "black"
      }}>
      <Grid
        className="centered header"
        size={{
          xs: 12
        }}>
        { name.length > 0 &&
          <>
            <em style={{ 
              fontStyle: "normal",
              color: "green"
            }}>{ name }</em>: 
          </>
        }
        { roll }
      </Grid>
      <Grid
        style={{
          padding: "4px"
        }}
        size={{
          xs: 12
        }}>
        <DisplayStringWithReplacements display_string={ result } />
      </Grid>
    </Grid>
  );
}
